// =====================
// Plan Selection + Add to Cart + Hero Sync
// =====================

// ---------- Helper: Sync Hero + Thumbnail ----------
function updateHeroImage(productKey) {
  const newSrc = heroImages[productKey];
  if (!newSrc) return;

  // Always target the FIRST hero image slide and FIRST thumbnail
  const firstHero  = document.querySelector('.pf-slide-main-media:first-of-type img');
  const firstThumb = document.querySelector('.pf-slide-list-media:first-of-type img');

  // Fade + swap hero
  if (firstHero && firstHero.src !== newSrc) {
    firstHero.style.opacity = 0;
    setTimeout(() => {
      firstHero.src = newSrc;
      firstHero.onload = () => (firstHero.style.opacity = 1);
    }, 150);
  }

  // Fade + swap thumbnail
  if (firstThumb && firstThumb.src !== newSrc) {
    firstThumb.style.opacity = 0;
    setTimeout(() => {
      firstThumb.src = newSrc;
      firstThumb.onload = () => (firstThumb.style.opacity = 1);
    }, 150);
  }

  // ---- FORCE jump back to hero image #1 (snap slider scroll) ----
  const slider = document.querySelector('.pf-media-slider[data-snap-slider-slides=".pf-slide-main-media"]');
  const firstSlide = document.querySelector('.pf-slide-main-media:first-of-type');

  if (slider && firstSlide) {
    const offset = firstSlide.offsetLeft;
    slider.scrollTo({
      left: offset,
      behavior: "smooth"
    });
  }
}

// ---------- Helper: Pre-order logic ----------
function isPreOrderActive() {
  const flag = window.compareAtConfig?.OUT_OF_STOCK ?? "NO";
  return flag.toString().toUpperCase() === "YES";
}

function getPreOrderProperties() {
  if (!isPreOrderActive()) return {};
  const msg = (window.compareAtConfig?.STOCK_BACK || "").toString().trim();
  return { "Pre-order": msg || "Backorder" };
}

// ---------- Helper: Sync order button ----------
function syncOrderButton() {
  const activeCard = document.querySelector('.plan-card.active');
  if (!activeCard) return;

   const allButtons = document.querySelectorAll('.orderbtn');
  if (!allButtons.length) return;

  const variantId   = activeCard.dataset.variantId;
  const planId      = activeCard.dataset.planId;
  const productKey  = activeCard.dataset.product;
  const selectedBox = activeCard.querySelector('.price-box.selected');
  const isSubscribe = selectedBox && selectedBox.dataset.value === 'subscribe';

  // --- Current displayed price (from the selected toggle) ---
  let totalPrice = parseFloat(
    (selectedBox?.querySelector('.floatprice')?.textContent || '0').replace('£', '')
  ) || 0;

// --- Base compare-at (undiscounted) ---
const BASE_ONE_OFF = window.compareAtConfig?.BASE_ONE_OFF || 39.99;
const STARTER_COMPARE = window.compareAtConfig?.STARTER_COMPARE || 111.99;

  let compareAtPrice = 0;
  if (productKey === 'starter') {
    compareAtPrice = STARTER_COMPARE;
  } else if (!isNaN(Number(productKey))) {
    compareAtPrice = BASE_ONE_OFF * Number(productKey);
  }

  // --- Upsell handling ---
  let upsellVariant = "", upsellPlan = "", upsellType = "none";
  const recommendBox = activeCard.querySelector('.recommend-box');

  if (recommendBox) {
    const dropdown  = recommendBox.querySelector('.recommend-select');
    const priceSub  = parseFloat(recommendBox.dataset.upsellPriceSub || '0') || 0;
    const priceOne  = parseFloat(recommendBox.dataset.upsellPriceOne || '0') || 0;
    upsellType      = dropdown?.value || "none";

    if (upsellType === "subscribe" || upsellType === "one-off") {
      upsellVariant = recommendBox.dataset.upsellVariant || "";
      upsellPlan    = (upsellType === "subscribe") ? (recommendBox.dataset.upsellPlan || "") : "";

      // Add the actual chosen upsell price to the total...
      totalPrice += (upsellType === "subscribe") ? priceSub : priceOne;

      // ...but ALWAYS add the upsell's full one-off price to compare-at
      compareAtPrice += priceOne;
    }
  }

  // If there's no real discount, hide compare-at (including exact equals)
  const hasDiscount = compareAtPrice > totalPrice + 0.009;

  // Update button datasets
 allButtons.forEach(btn => {
    btn.dataset.variantId     = variantId;
    btn.dataset.sellingPlan   = isSubscribe ? (planId || "") : "";
    btn.dataset.upsellVariant = upsellVariant;
    btn.dataset.upsellPlan    = upsellPlan;
    btn.dataset.upsellType    = upsellType;

    const prefix = isPreOrderActive() ? "Pre-order" : "Add to cart";

    if (hasDiscount) {
      btn.innerHTML = `${prefix} – <s>£${compareAtPrice.toFixed(2)}</s> £${totalPrice.toFixed(2)}`;
    } else {
      btn.textContent = `${prefix} – £${totalPrice.toFixed(2)}`;
    }
  });
}

// ---------- Add to Cart ----------
function addToCart(variantId, plan, properties = {}) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity: 1, id: variantId, selling_plan: plan || null, properties },
    dataType: 'json',
    success: () => console.log("Product added to cart"),
    error: (error) => console.error("Error adding product:", error)
  });
}

// ---------- Initialize Variant Selector Swiper ----------
const variantSwiper = new Swiper(".variant-swiper", {
  slidesPerView: 3.3,
  autoHeight: true,
  spaceBetween: 15,
  slideToClickedSlide: true,
  centeredSlides: true,
  centeredSlidesBounds: true,   
  initialSlide: 1,
  grabCursor: true,
  navigation: {
    nextEl: ".variant-next",
    prevEl: ".variant-prev",
  },
  breakpoints: {
    0: { slidesPerView: 3, spaceBetween: 10 },
    768: { slidesPerView: 3.3 },
    1024: { slidesPerView: 3.3 },
  },
  observer: true,
observeParents: true,
});

// ---------- Starter Plan Visibility Logic ----------
function applyStarterVisibilityLogic() {
  // Default to YES if flag is missing
  const showStarterFlag = window.compareAtConfig?.SHOW_STARTER_PLAN || "YES";
  const showStarter = showStarterFlag.toString().toUpperCase() === "YES";

  if (showStarter) {
    // Do nothing – keep current starter behaviour
    return;
  }

  // 1) Hide starter selector slide
  const starterSelector = document.querySelector('.selector-item[data-product="starter"]');
  if (starterSelector) {
    const starterSlide = starterSelector.closest('.swiper-slide');
    starterSelector.classList.remove('active');

    if (starterSlide) {
      starterSlide.classList.remove('active');
      starterSlide.style.display = 'none';

      // Optional: also remove from Swiper so spacing is perfect
      if (typeof variantSwiper !== "undefined" && variantSwiper.removeSlide) {
        const slideIndex = Array.from(starterSlide.parentNode.children).indexOf(starterSlide);
        if (slideIndex > -1) {
          variantSwiper.removeSlide(slideIndex);
        }
      }
    }
  }

  // 2) Hide starter plan card
  const starterCard = document.querySelector('.plan-card[data-product="starter"]');
  if (starterCard) {
    starterCard.classList.remove('active');
    starterCard.style.display = 'none';
  }

  // 3) Set 2-pouch as the default active
  const defaultKey = "1";

  // Plan cards
  document.querySelectorAll(".plan-card").forEach(card => {
    card.classList.toggle("active", card.dataset.product === defaultKey);
  });

  // Selector items
  document.querySelectorAll(".selector-item").forEach(el => el.classList.remove("active"));
  const defaultSelector = document.querySelector(`.selector-item[data-product="${defaultKey}"]`);
  if (defaultSelector) {
    defaultSelector.classList.add("active");
    const slide = defaultSelector.closest(".swiper-slide");
    if (slide) {
      slide.classList.add("active");

      // Make sure Swiper centers this slide
      if (typeof variantSwiper !== "undefined" && variantSwiper.slideTo) {
        const idx = Array.from(slide.parentNode.children).indexOf(slide);
        if (idx > -1) {
          variantSwiper.slideTo(idx, 0);
        }
      }
    }
  }
}

// ---------- Variant Click ----------
document.querySelectorAll(".selector-item").forEach(item => {
  item.addEventListener("click", e => {
    const selectorItems = document.querySelectorAll(".selector-item");
    const selectorSlides = document.querySelectorAll(".variant-swiper .swiper-slide");

    // 1) Clear active from all selector items + their slides
    selectorItems.forEach(el => el.classList.remove("active"));
    selectorSlides.forEach(slide => slide.classList.remove("active"));

    // 2) Activate the clicked selector item + its slide
    const clickedItem = e.currentTarget;
    clickedItem.classList.add("active");
    const clickedSlide = clickedItem.closest(".swiper-slide");
    if (clickedSlide) clickedSlide.classList.add("active");

    // 3) Show matching plan card
    const productKey = clickedItem.dataset.product;
    document.querySelectorAll(".plan-card").forEach(card => {
      card.classList.toggle("active", card.dataset.product === productKey);
    });

    // 4) Update button + hero image
    syncOrderButton();
    updateHeroImage(productKey);
  });
});

// ---------- Subscribe / One-off Toggle ----------
document.querySelectorAll(".plan-card .price-box").forEach(box => {
  box.addEventListener("click", e => {
    const card = e.currentTarget.closest(".plan-card");
    card.querySelectorAll(".price-box").forEach(b => b.classList.remove("selected"));
    e.currentTarget.classList.add("selected");
    syncOrderButton();
  });
});

// ---------- Dropdown Change ----------
document.querySelectorAll(".recommend-select").forEach(select => {
  select.addEventListener("change", () => syncOrderButton());
});

// ---------- Add to Cart Button ----------
document.addEventListener("click", e => {
  const btn = e.target.closest(".orderbtn");
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const sellingPlan = btn.dataset.sellingPlan;
  const upsellVariant = btn.dataset.upsellVariant;
  const upsellPlan = btn.dataset.upsellPlan;
  const upsellType = btn.dataset.upsellType;

  if (!variantId) return;

  const originalHtml = btn.innerHTML;   // preserves <s> compare-at
  btn.textContent = "Adding...";

   const properties = getPreOrderProperties(); // {} or { "Pre-order": "Ships mid-March" }
  addToCart(variantId, sellingPlan, properties);

  if (upsellType !== "none" && upsellVariant) {
    setTimeout(() => {
      const planToUse = (upsellType === "subscribe") ? (upsellPlan || null) : null;
      addToCart(upsellVariant, planToUse);
    }, 400);
  }

  setTimeout(() => {
    btn.innerHTML = originalHtml;
    syncOrderButton();
  }, 1200);
});

// ---------- Init on Load ----------
document.addEventListener("DOMContentLoaded", () => {
  // First, apply show/hide logic for the starter plan
  applyStarterVisibilityLogic();

  // Then initialise hero + buttons based on whichever card is now active
  const activeCard = document.querySelector('.plan-card.active');
  if (activeCard) {
    updateHeroImage(activeCard.dataset.product);
  }
  syncOrderButton();
});

// ---------- Equalize selector-item heights ----------
function equalizeSelectorHeights() {
  const items = document.querySelectorAll(".selector-item");
  if (!items.length) return;

  // Reset any inline height first (in case of resize)
  items.forEach(item => item.style.minHeight = "");

  // Get tallest height
  const tallest = Math.max(...Array.from(items).map(el => el.offsetHeight));

  // Apply min-height to all
  items.forEach(item => (item.style.minHeight = `${tallest}px`));

   // ✅ IMPORTANT: force Swiper to recalc wrapper height
  if (typeof variantSwiper !== "undefined" && variantSwiper?.updateAutoHeight) {
    variantSwiper.updateAutoHeight(0);
  }
}

// Run on load + resize
window.addEventListener("load", () => {
  equalizeSelectorHeights();
  requestAnimationFrame(() => variantSwiper.updateAutoHeight(0));
});

window.addEventListener("resize", () => {
  clearTimeout(window._selectorHeightTimer);
  window._selectorHeightTimer = setTimeout(() => {
    equalizeSelectorHeights();
    variantSwiper.updateAutoHeight(0);
  }, 200);
});

// ---------- "Go to Plan" Link Handler ----------
document.querySelectorAll(".goto-plan").forEach(link => {
  link.addEventListener("click", e => {
    e.preventDefault();

    const targetKey = e.currentTarget.dataset.target;
    if (!targetKey) return;

    // Remove active from all cards
    document.querySelectorAll(".plan-card").forEach(card => 
      card.classList.remove("active")
    );

    // Activate target card
    const targetCard = document.querySelector(`.plan-card[data-product="${targetKey}"]`);
    if (targetCard) {
      targetCard.classList.add("active");
      targetCard.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // Sync order button and hero image
    syncOrderButton();
    updateHeroImage(targetKey);

    // If you’re also using a top selector slider, update its active state:
    const selectorItem = document.querySelector(`.selector-item[data-product="${targetKey}"]`);
    if (selectorItem) {
      document.querySelectorAll(".selector-item").forEach(el => el.classList.remove("active"));
      selectorItem.classList.add("active");

      // Center that selector slide (if using Swiper)
      if (typeof variantSwiper !== "undefined") {
        const slideIndex = Array.from(selectorItem.closest(".swiper-wrapper").children).indexOf(selectorItem.closest(".swiper-slide"));
        variantSwiper.slideTo(slideIndex, 300);
      }
    }
  });
});